@if (notification()) {
  <div class="notification-banner" [ngClass]="bannerClasses()">
    <div class="banner-icon">
      @if (notification()?.type === 'info') {
        <svg fill="currentColor" viewBox="0 0 24 24" width="18" height="18"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v2h-2zm0 4h2v6h-2z"/></svg>
      } @else {
        <span [innerHTML]="getIconSVG()"></span>
      }
    </div>
    <div class="banner-content">
      @if (notification()!.label) {
        <span class="banner-label">{{ notification()!.label }}</span>
      }
      <span class="banner-message">{{ notification()!.message }}</span>
      @if (notification()!.detail) {
        <span class="banner-detail">{{ notification()!.detail }}</span>
      }
    </div>
    <button class="banner-dismiss" (click)="dismiss()" title="Dismiss">
      <svg fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
    </button>
  </div>
}